import React, { useEffect, useRef } from "react";

// Table checkbox of the design system (checkbox-container / checkmark) with checked, partial and disabled states.
// The click never reaches the row, so a selectable row can also be a link.
const CustomCheckbox = ({ checked = false, indeterminate = false, disabled = false, onChange, ariaLabel }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) inputRef.current.indeterminate = indeterminate && !checked;
    }, [indeterminate, checked]);

    return (
        <label className="checkbox-container" onClick={(event) => event.stopPropagation()}>
            <input ref={inputRef} type="checkbox" checked={checked} disabled={disabled} onChange={onChange} aria-label={ariaLabel} />
            <span className="checkmark" />
        </label>
    );
};

export default CustomCheckbox;
